import {useEffect, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import {fetchFilters} from "../../../../redux/operations/FactoryOperations";
import {selectCountries} from "../../../../redux/selectors/FactorySelectors";

const useCountryIdOptionsService = () => {
  const dispatch = useDispatch();
  const {i18n} = useTranslation();

  const countries = useSelector(selectCountries);

  useEffect(() => {
    if (!countries || countries?.length < 1) {
      dispatch(fetchFilters());
    }
  }, []);

  const countriesOptions = useMemo(() => {
    const lang = i18n?.language?.toLowerCase?.() || "uk";
    const isEnglish = lang.startsWith("en");
    return (
      countries?.map(({countryId, shortName, shortNameEng}) => ({
        title: isEnglish ? shortNameEng || shortName : shortName || shortNameEng,
        value: countryId,
      })) || []
    );
  }, [countries, i18n?.language]);

  return countriesOptions;
};

export default useCountryIdOptionsService;
